import axios from 'axios'

const externalClient = axios.create({
  baseURL: 'https://api.vvhan.com/api/',
  timeout: 6000,
  headers: {
    'Content-Type': 'application/json;charset=utf-8'
  }
})

export default externalClient
